import * as ACTION_TYPES from '../types';

let initialState = {
  project: null,
  user: null,
  error: null,
  loading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.GET_AUTHORIZED_PROJECT_AND_USER:
      return { ...state, loading: true };
    case ACTION_TYPES.SET_AUTHORIZED_PROJECT_AND_USER:
      return {
        ...state,
        project: action.payload.project,
        user: action.payload.user,
        loading: false
      };
    case ACTION_TYPES.AUTHORIZE_PROJECT_AND_USER_FAIL:
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
};
